import React, { memo, forwardRef } from "react";
const SvgEta = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M20.52 25.864a1 1 0 01-1-1V11.872c0-1.024-.224-1.792-.672-2.304-.448-.528-1.144-.792-2.088-.792-.896 0-1.616.184-2.16.552-.528.352-.912.872-1.152 1.56-.224.688-.336 1.536-.336 2.544v5.672a1 1 0 01-1 1H12a1 1 0 01-1-1V8.167a.927.927 0 011.84-.162l.176.987h.12a4.018 4.018 0 011.032-1.104 4.08 4.08 0 011.344-.672A5.567 5.567 0 0117.072 7c.992 0 1.824.168 2.496.504.672.32 1.176.832 1.512 1.536.352.688.528 1.584.528 2.688v13.136a1 1 0 01-1 1h-.088z"
      />
    </svg>
  );
});
SvgEta.displayName = "SvgEta";
const MemoForwardRef = memo(SvgEta);
export default MemoForwardRef;
